// import '../../App.scss';
import React, { useState, Component } from 'react';
import TextBox from '../Atoms/TextBox';
import Chip from '../Atoms/Chip';
import ReactMarkdown from 'react-markdown'

import { SRLWrapper } from "simple-react-lightbox";





class WorksDescription extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   itemData: 
    // };
  }
  

  render() {
    
    const {data} = this.props;
    const options = {
      settings: {
        overlayColor: "rgba(255, 255, 255, 1)"
      }
    };


    // console.log(data);
    
    return (
      <div>
        {data.fields ? 
              <div className="flex wrap work-description phone-flex-column" style={{minHeight: '500px'}}> 
              

              {/* COL 1 */}
              <div className="flex-3 bt br bb phone-bb-0 flex flex-column">
                <TextBox cx="" border="bb" firstLevel="h2" secondLevel="i" thirdLevel="p" cx="" firstContent={data.fields.title} secondContent={data.fields.titleEnglish} thirdContent={data.fields.exhibitionPlace}/>
                
                  
                <div className="flex wrap flex-column phone-h-25" style={{height: "100%"}} >
                  <ReactMarkdown className="pl-m pr-m pt-m pb-m flex-1 phone-pl-s phone-pr-s lh-m">{data.fields.description}</ReactMarkdown>
                    
                  <div className="pos-relative h-3 pl-m phone-pl-s">
                    <Chip linkTo="/filter/vaerker"content={data.metadata.tags[0].sys.id} absolute="true" />
                  </div>

                </div>
              </div>
    
            {/* COL 2 */}
            
                <div className="flex-3 bt br bb phone-bb-0">
                <SRLWrapper options={options}>
                {/* <SRLWrapper > */}
                

                
                  <div className="flex wrap ">
                    <div className="flex w-100 bb h-3 pl-m pr-m phone-pl-s phone-pr-s">
                      <h2 className="margin-t-s phone-h-6">
                        DOKUMENTATION <span>{`(${data.fields.installationImages.length})`}</span>
                      </h2>
                    </div>
                    {data.fields.installationImages.map((installationImage, index) => (
                      <a className="gallery-thumbnail-wrapper flex w-25 h-100px" href={installationImage.fields.file.url} >
                        <img className="gallery-thumbnail w-100 fit-cover " src={`${installationImage.fields.file.url}?w=300&h=300&fm=jpg&fl=progressive`} key={index} alt={installationImage.fields.title}></img>
                      </a>
                    ) 
                    )}
                  </div>

                  </SRLWrapper>
                </div>
              
            {/* COL 3 */}

              <div className="flex-3 flex space-between bt bb wrap flex-column">
                
                <div className="flex wrap bb h-3 pt-s pl-m pr-m items-top phone-h-25 phone-pl-s phone-pr-s" style={{flexGrow:"3"}}>
                  <h2 className="w-100 phone-h-6">
                      OM UDSTILLINGEN
                  </h2>
                  <ReactMarkdown className="w-100 lh-m">
                    {data.fields.practicalInfo}
                  </ReactMarkdown>
                </div>

                <div className="flex wrap h-3 bb pt-s pl-m pr-m items-top phone-pl-s phone-pr-s" style={{flexGrow:"1"}}>
                  <h2 className="w-100">
                      LYDFILER
                  </h2>
                  <div className="flex wrap">

                  {data.fields.sound ? 
                  data.fields.sound.map((soundFile, index) => (
                    <a className="external-link w-100 pb-s pt-s" href={soundFile.fields.file.url} >
                      {`Lydfil - ${index +1}`}
                    </a>
                    
                    ) 
                    )
                    : 
                    "" 
                  
                  }

                  </div>  

                </div>


                <div className="flex wrap h-3  pt-s pl-m pr-m items-top phone-pl-s phone-pr-s" style={{flexGrow:"1"}}>
                  <h2 className="w-100">
                      LINKS
                  </h2>
                  <div className="flex wrap">

                  {data.fields.externalLinks ? 
                  data.fields.externalLinks.map((link, index) => (
                    <a className="underline external-link w-100 pb-s pt-s" href={link} >
                      {link}
                    </a>
                    
                    ) 
                    )
                    : 
                    "" 
                  
                  }

                  </div>  

                </div>

              </div>

          </div>
        : 
        <p>Henter data... 📡 </p>}
      </div>

    
    );
  }
}


export default WorksDescription;



// {/* <div className="w-100">
//           <ChipSection />
//         </div>